/*
 * @Description:
 * @Version: 1.0
 * @Author: changfeng
 * @Date: 2024-06-24 14:03:46
 * @LastEditors: changfeng
 * @LastEditTime: 2024-07-02 13:46:14
 */
/* eslint-disable */
// 该文件由 OneAPI 自动生成，请勿手动修改！
import { request } from '@umijs/max';

/** 使用用户名，密码登陆 */
export async function loginApi(
  params: LoginForm,
  options?: { [key: string]: any },
) {
  return request<API.PageInfo_Login>('/api/login', {
    method: 'POST',
    data: {
      ...params,
    },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 POST /api/v1/user */
export async function getCurrentUser(
  body?: API.UserInfo,
  options?: { [key: string]: any },
) {
  return request<API.Result>('/api/user/current', {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 GET /api/v1/user/${param0} */
export async function getCaptchaCode(
  params: {
    // path
    /** userId */
    email: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.Result>(`/api/user/ecode`, {
    method: 'GET',
    params: { ...params },
    ...(options || {}),
  });
}

/** 此处后端没有提供注释 DELETE /api/v1/user/${param0} */
export async function resetPassword(
  params: {
    // path
    /** userId */
    email: string;
    password: string;
    code: string;
  },
  options?: { [key: string]: any },
) {
  return request<API.Result>(`/api/user/resetPwd`, {
    method: 'POST',
    data: { ...params },
    ...(options || {}),
  });
}
